import React, { useMemo, useState } from 'react';
import Axios from 'axios';
import { FormattedMessage } from "react-intl";

const ContactFrom = () => {
  const initialForm = {
    firstName: '',
    lastName: '',
    subject: '',
    email: '',
    contactNumber: '',
    message: '',
  };

  const [sent, setSent] = useState(false);
  const [fieldError, setFieldError] = useState(false);
  const [formData, setFormData] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  const hasValidFields = useMemo(() => (
    formData.subject
    && formData.firstName
    && formData.lastName
    && formData.contactNumber
    && formData.email
    && formData.message
    // eslint-disable-next-line no-useless-escape
    && /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(formData.email)
  ), [formData]);

  const handleInputChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (hasValidFields) {
      try {
        setLoading(true);
        await Axios.post('https://us-central1-massam-9ccfb.cloudfunctions.net/submit', formData);
        setSent(true);
        setFormData(initialForm);
        setFieldError(false);
        setLoading(false);
      } catch (e) {
        setSent(false);
        setFieldError(true);
        setLoading(false);
      }
    } else if (!hasValidFields) {
      setSent(false);
      setFieldError(true);
    }
  };

  return (
    <form onSubmit={handleSubmit} noValidate className="row">
      {
        sent && !fieldError && <p className="col-12 px-md-3 mb-3 success"><FormattedMessage id="successMessage"/></p>
      }
      {
        fieldError && <p className="col-12 px-md-3 mb-3 warning"><FormattedMessage id="invalidFieldsMessage"/></p>
      }
      <div className="col-12 col-md-6 px-md-3 mb-3">
        <label htmlFor="firstName">
          <FormattedMessage id="formLabelFirstName"/>*
        </label>
        <input
          id="firstName"
          type="text"
          name="firstName"
          value={formData.firstName}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-6 px-md-3 mb-3">
        <label htmlFor="lastName">
          <FormattedMessage id="formLabelLastName"/>*
        </label>
        <input
          id="lastName"
          type="text"
          name="lastName"
          value={formData.lastName}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-6 px-md-3 mb-3">
        <label htmlFor="contactNumber">
          <FormattedMessage id="formLabelContact"/>*
        </label>
        <input
          id="contactNumber"
          type="text"
          name="contactNumber"
          value={formData.contactNumber}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 col-md-6 px-md-3 mb-3">
        <label htmlFor="email">
          <FormattedMessage id="formLabelEmail"/>*
        </label>
        <input
          id="email"
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 px-md-3 mb-3">
        <label htmlFor="subject">
          <FormattedMessage id="formLabelSubject"/>*
        </label>
        <input
          id="subject"
          type="text"
          name="subject"
          value={formData.subject}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 px-md-3 mb-3">
        <label htmlFor="message">
          <FormattedMessage id="formLabelMessage"/>*
        </label>
        <textarea
          id="message"
          type="text"
          name="message"
          value={formData.message}
          onChange={handleInputChange}
        />
      </div>

      <div className="col-12 px-md-3 submit">
        {loading && <div className="loader"/>}
        <button type="submit" disabled={loading}><FormattedMessage id="formSubmit"/></button>
      </div>
    </form>
  );
};

export default ContactFrom;
